import Text, { TextProps } from "./Text";

export default function TextTitleMinor(props: TextProps) {
  return <Text style="subtitle">{props.children}</Text>;
}
